const AI_SETTINGS_INITIAL_STATES = {
  areMlIngredientsEnabled: true,
}

export default AI_SETTINGS_INITIAL_STATES
